import { SettingOutlined } from "@ant-design/icons";
import * as React from "react";
import { ZClassifier } from "src/business/classifier";
import {
  columnDisplayId,
  sysColumnsHistory,
} from "src/business/sysData/sysColumns";
import { makeMdmActionColumn, RenderLinkAction } from "src/components/MdmTable";
import { RtColumn } from "src/components/ReactiveTable/RtColumn";
import { makeUrl } from "src/routes/makeUrl";
import { PageUrl } from "src/routes/PageUrl";

export const buildClassifiersColumns = (
  isMetaEditor: boolean,
): RtColumn<ZClassifier>[] => {
  const columns: RtColumn<ZClassifier>[] = [
    columnDisplayId,
    {
      key: "name",
      title: "Название",
      render: (row) => row.name,
    },
    {
      key: "description",
      title: "Описание",
      render: (row) => row.description,
    },
    ...sysColumnsHistory,
  ];
  if (isMetaEditor)
    columns.push(
      makeMdmActionColumn<ZClassifier>({
        key: "settings",
        render: ({ id }) => (
          <RenderLinkAction
            icon={<SettingOutlined />}
            tooltip="Открыть настройки в новой вкладке"
            href={makeUrl(PageUrl.managementClassifierCard, { id })}
          />
        ),
      }),
    );
  return columns;
};
